import { defineNuxtPlugin, useVisitorIdCookie } from '#imports'

export default defineNuxtPlugin({
    name: 'visitorId',
    parallel: true,
    setup() {
        const { setVisitorIdCookie } = useVisitorIdCookie()

        setVisitorIdCookie()
    },
})
